/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint  no-param-reassign: 0 */
export const BHOOT_motor_single = (block, generator) => {
  let direccion1 = 0;
  let direccion2 = 0;

  const doublePin = block.getFieldValue('NPIN').split(',');
  const dropdown_pin1 = doublePin[0];
  const dropdown_pin2 = doublePin[1];

  switch (block.getFieldValue('DIR')) {
    default:
    case '3':
      direccion1 = (block.workspace?.currentBoardVersion?.butyV2) ? 'LOW' : 'HIGH';
      direccion2 = 'HIGH';
      break;
    case '4':
      direccion1 = (block.workspace?.currentBoardVersion?.butyV2) ? 'HIGH' : 'LOW';
      direccion2 = (block.workspace?.currentBoardVersion?.butyV2) ? 'LOW' : 'HIGH';
      break;
    case '6':
      direccion1 = 'LOW';
      direccion2 = 'LOW';
      break;
  }

  generator.setups_[`setup_motors_single_${dropdown_pin1}`] = `
pinMode(${dropdown_pin1}, OUTPUT);
pinMode(${dropdown_pin2}, OUTPUT);
`;

  const code = `
  digitalWrite(${dropdown_pin1}, ${direccion1});
  digitalWrite(${dropdown_pin2}, ${direccion2});
`;

  return code;
};

// Divergencia deliberada: el legacy emitía `__p += __p += ...` y duplicaba los
// digitalWrite; acá se emiten una sola vez. Siempre setups_: los pines vienen de dropdown.
const MOTOR_DOBLE_DIRS = {
  3: ['HIGH', 'LOW', 'HIGH', 'LOW'],
  4: ['LOW', 'HIGH', 'LOW', 'HIGH'],
  5: ['LOW', 'HIGH', 'HIGH', 'LOW'],
  6: ['HIGH', 'LOW', 'LOW', 'HIGH'],
  7: ['LOW', 'LOW', 'LOW', 'LOW'],
};

export const SALIDAS_motor = (block, generator) => {
  const [pin1, pin2] = block.getFieldValue('NPIN').split(',');
  const dirs = { 3: ['HIGH', 'LOW'], 4: ['LOW', 'HIGH'], 6: ['LOW', 'LOW'] };
  const [dir1, dir2] = dirs[block.getFieldValue('NPIN1')] || [];

  generator.setups_[`${pin2}${pin1}`] = `pinMode(${pin1},OUTPUT);\n pinMode(${pin2},OUTPUT);\n`;
  return `digitalWrite(${pin1},${dir1});\n digitalWrite(${pin2},${dir2});\n`;
};

export const SALIDAS_motor_doble = (block, generator) => {
  const [pin2, pin1] = block.getFieldValue('NPIN').split(',');
  const [pin3, pin4] = block.getFieldValue('NPIN2').split(',');
  const [dir1, dir2, dir3, dir4] = MOTOR_DOBLE_DIRS[block.getFieldValue('NPIN1')] || [];

  generator.setups_[`${pin2}${pin1}${pin3}${pin4}`] = `pinMode(${pin1},OUTPUT);\n pinMode(${pin2},OUTPUT);\n pinMode(${pin3},OUTPUT);\n pinMode(${pin4},OUTPUT);\n`;
  return `digitalWrite(${pin1},${dir1});\n digitalWrite(${pin2},${dir2});\n digitalWrite(${pin3},${dir3});\n digitalWrite(${pin4},${dir4});\n`;
};

export const SALIDAS_motor_doble_pwm = (block, generator) => {
  let pwm = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || '';
  // Clamp 0-255 del legacy, con su isNumeric roto corregido: solo recorta
  // literales fuera de rango; un input variable pasa intacto.
  const n = parseInt(pwm, 10);
  if (!Number.isNaN(n) && (n > 255 || n < 0)) pwm = '255';

  const [pin1, pin2, pin5] = block.getFieldValue('NPIN').split(',');
  const [pin4, pin3, pin6] = block.getFieldValue('NPIN2').split(',');
  const [dir1, dir2, dir3, dir4] = MOTOR_DOBLE_DIRS[block.getFieldValue('NPIN1')] || [];

  generator.setups_[`${pin2}${pin1}${pin3}${pin4}${pin5}${pin6}`] = `pinMode(${pin1},OUTPUT);\n  pinMode(${pin2},OUTPUT);\n  pinMode(${pin3},OUTPUT);\n  pinMode(${pin4},OUTPUT);`;
  return `analogWrite(${pin5},${pwm});\nanalogWrite(${pin6},${pwm});\ndigitalWrite(${pin1},${dir1});\ndigitalWrite(${pin2},${dir2});\ndigitalWrite(${pin3},${dir3});\ndigitalWrite(${pin4},${dir4});\n`;
};

// ------------------------------ Servos senior -------------------------------

const includeServo = (generator, pin) => {
  generator.definitions_['include_servo'] = '#include <Servo.h>\n\n';
  generator.definitions_[`include_servo_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`servo_move_${pin}`] = `servo_${pin}.attach(${pin});`;
};

export const servo_move = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return `servo_${pin}.write(${angle});\n`;
};

export const servo_read = (block, generator) => {
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return [`servo_${pin}.read()`, generator.ORDER_ATOMIC];
};